import React from 'react';

import { Accordion } from 'features/order-tracker/shared-components';

import styles from './styles.module.scss';

export const EngineerVisitAccordion: React.FC<components.EngineerVisitAccordion> = ({
  index,
  title,
  content,
  isExpanded,
  setActiveAccordionInfo,
}) => {
  const toggleEngineerVisitAccordion = (): void => {
    const updatedIndex = isExpanded ? -1 : index;
    setActiveAccordionInfo(updatedIndex);
  };

  return (
    <Accordion
      key={title}
      title={<h4>{title}</h4>}
      isExpanded={isExpanded}
      className={styles.accordionItem}
      toggleEvent={toggleEngineerVisitAccordion}
    >
      {content}
    </Accordion>
  );
};
